import { Component } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../services/config.service';

@Component({
    selector: 'itpx-missing',
    templateUrl: './missing.component.html',
    styleUrls: [ './missing.component.css' ]
})

export class MissingComponent {


    constructor( private configService: ConfigService, private http: Http ) {
    }

}


// WEBPACK FOOTER //
// ./src/app/core/components/missing/missing.component.ts